import React from "react";
import { default as Text } from "./Text";
import { default as Image } from "./Image";

const GameOpt = ({ content }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        height: "85%",
        marginTop: "5%",
        width: "170%",
        position: "relative",
      }}
    >
      <img
        height={"100%"}
        src={content.menu_src}
        style={{
          maxHeight: "560px",
          justifySelf: "flex-start",
          marginRight: "50px",
        }}
      />
      <div style={{ height: "100%", width: "100%" }}>
        {content.inner_content &&
          content.inner_content.map((obj, i) => {
            if (obj.component === "text") {
              return <Text key={`body${i}`} content={obj} />;
            } else if (obj.component === "image") {
              return <Image key={`body${i}`} content={obj} />;
            }
          })}
      </div>
    </div>
  );
};

export default GameOpt;
